<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>Sort Builder</h2>

<mat-dialog-content style="overflow-y: hidden; height: 300px; ">
    <div style="margin-top: 10px; width: 100%; max-height: 200px; display: flex;">
        <div class="list-panel">
            <h3 style="color: #d36b0b;">Available Columns</h3>
            <mat-selection-list #list [multiple]="false"
                style="background-color: #161616; overflow-y: auto; height: 100%;">
                <mat-list-option *ngFor="let field of fields" [value]="field">{{field}}</mat-list-option>
            </mat-selection-list>

        </div>
        <div style="margin-top: 50px; flex: 0;">
            <button mat-icon-button color="primary" (click)="newItem(list.selectedOptions.selected[0]?.value)">
                <mat-icon class="material-icons">keyboard_double_arrow_right</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="removeItem(sortList.selectedOptions.selected[0]?.value)">
                <mat-icon class="material-icons">keyboard_double_arrow_left</mat-icon>
            </button>
        </div>
        <div class="list-panel">
            <h3 style="color: #d36b0b;">Sorted Columns</h3>
            <div style="height: 100%; display: flex; flex-direction: column;">
                <mat-selection-list style="flex: 1; background-color: #161616; overflow-y: auto; height: 100%" #sortList
                     [multiple]="false" >  <!--(selectionChange)="sortInfoSelected($event)" -->
                    <mat-list-option *ngFor="let sortInfo of sortItems" [value]="sortInfo">
                        <mat-chip (click)="sortInfoSelected(sortInfo)">{{sortInfo.sortField}}
                            <mat-icon class="primary-color-icon" style="font-size: 8px"
                                *ngIf="sortInfo.sortAscending" style="margin-left: 3px;">
                                keyboard_arrow_down
                            </mat-icon>
                            <mat-icon class="primary-color-icon" style="font-size: 8px"
                                *ngIf="!sortInfo.sortAscending" style="margin-left: 3px;">
                                keyboard_arrow_up
                            </mat-icon>
                        </mat-chip>
                    </mat-list-option>
                </mat-selection-list>

                <!-- <fieldset *ngIf="selectedSortInfo" style="border:1px solid #d36b0b; margin-top: 16px;">
                    <legend style="color: #d36b0b;">Sort Order</legend>
                    <div>
                        <input type="radio" id="asc" name="sortOrder" [value]="true"
                            [(ngModel)]="selectedSortInfo.sortAscending">
                        <label>Ascending</label>
                    </div>

                    <div>
                        <input type="radio" id="desc" name="sortOrder" [value]="false"
                            [(ngModel)]="selectedSortInfo.sortAscending">
                        <label>Descending</label>
                    </div>
                </fieldset> -->
            </div>

        </div>

    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="saveChanges()" tabindex="1">SAVE</button>
    <button style="margin-left: 10px" mat-raised-button [mat-dialog-close]="false" tabindex="-1">CANCEL</button>
</mat-dialog-actions>
</div>

